import React from 'react';

export const AppTabs = ({
    tabs = [],
    activeTab,
    onChange,
    navClassName = 'nav nav-tabs flex-wrap w-100 text-center customers-nav-tabs',
    itemClassName = 'nav-item flex-fill border-top',
}) => {
    return (
        <ul className={navClassName} role="tablist">
            {tabs.map((tab) => (
                <li className={itemClassName} role="presentation" key={tab.key}>
                    <button
                        type="button"
                        className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => onChange(tab.key)}
                    >
                        {tab.label}
                    </button>
                </li>
            ))}
        </ul>
    );
};
